import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavAiChatbot = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M7 2H2v5h5V2ZM22 12H2v5h20v-5ZM22 12H7V7h5V2h10v10ZM7 22v-5h5l-5 5Z"
    />
  </svg>
);
export default SvgNavAiChatbot;
